/**
 * Shared helpers for hospital-connected vs standalone pharmacy behavior.
 * Use these instead of checking hospital_id or isHospitalConnected alone.
 */

export const isHospitalConnected = (pharmacyPOS) =>
	pharmacyPOS?.isHospitalConnected === true &&
	Boolean(pharmacyPOS?.hospital_id);

export const pharmacyCollectsPayment = (pharmacyPOS) =>
	Boolean(
		pharmacyPOS?.pharmacy_collects_payment ??
			pharmacyPOS?.hospital?.pharmacy_collects_payment
	);

export const canShowPatientAccounts = (pharmacyPOS) =>
	isHospitalConnected(pharmacyPOS) && pharmacyCollectsPayment(pharmacyPOS);
